import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../Common/Sidebar";
import Loader from "../Common/Loader";
import { TabView, TabPanel } from "primereact/tabview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "react-bootstrap";
import CommonValues from "../Common/utils";

export default function  CDDepartmentLandingPage() {
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const onSidebarValueChanged = (value: any) => {
    setShowWideSidebar(value);
  };

  useEffect(() => {
    const token = CommonValues.GetToken();
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const fetchDepartments = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/department/get`,
          { headers }
        );
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.data || response.data?.departments || [];
        setDepartments(data);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };
    const fetchAllData = async () => {
      setLoading(true);
      await fetchDepartments();
      setLoading(false);
    };
    fetchAllData();
  }, []);

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar
        pagename="department"
        onSidebarValueChanged={onSidebarValueChanged}
      />
      <div className="flex-grow-1 d-flex flex-column bg-light p-2 mt-4">
        <div className={`${
            showWideSidebar
              ? "main-content-large-width"
              : "main-content-small-width"
          }`}
        >
          <div>
            <h2 className="fw-bold">Departments</h2>
            <p className="text-muted">
              Browse all departments in the company
            </p>
          </div>

          <div className="card p-3">
            <div className="d-flex mt-4 mb-4 gap-4 dashboard-container">
              <div className="info-block dashboard-card shadow-hover p-3 rounded-4 w-100 d-flex align-items-center justify-content-between">
                <div>
                  <p className="dashboard-label mb-1">Departments</p>
                  <h2 className="dashboard-number mb-1">
                    {Array.isArray(departments) ? departments.length : 0}
                  </h2>
                  <p className="text-muted text-12 mb-0">Active departments</p>
                </div>
                <i className="pi pi-building text-success fs-1" />
              </div>
            </div>

            {loading ? (
              <div className="d-flex justify-content-center">
                <Loader />
              </div>
            ) : (
              <TabView className="mb-2 tabview-tab">
                <TabPanel header="List View">
                  <DataTable
                    value={departments}
                   className="support-call-table custom-bordered-datatable text-14"
                    emptyMessage="No departments found."
                    paginator rows={5}
                  >
                    <Column field="departmentName" header="Name" sortable />
                    <Column field="description" header="Description" />
                    <Column field="city" header="City" />
                    <Column field="state" header="State" />
                    <Column field="contactNo" header="Contact" />
                  </DataTable>
                </TabPanel>
              </TabView>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
